import { z } from "zod";

export const ZRadonSchema = z.object({
  // 7
  isActive: z.boolean().default(false),
  tekst: z.string(),
  radonsperre: z.object({
    // 7.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
    underpunkter: z.object({
      A: z.object({ isActive: z.boolean().default(false), tekst: z.string() }),
      B: z.object({
        isActive: z.boolean().default(false),
        tekst: z.string(),
        rettUnderPastoep: z.object({
          isActive: z.boolean().default(false),
          tekst: z.string(),
        }),
        radonsperreMedIsoOver: z.object({
          isActive: z.boolean().default(false),
          tekst: z.string(),
        }),
      }),
      C: z.object({ isActive: z.boolean().default(false), tekst: z.string() }),
    }),
    gjennomforinger: z.object({
      // 7.1.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  radonbronner: z.object({
    // 7.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
    horisontaleRadonbronner: z.object({
      // 7.2.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
});

export type IRadonSchema = z.infer<typeof ZRadonSchema>;
